export default "__VITE_ASSET__2d0fab06__"